// extracted by mini-css-extract-plugin
module.exports = {"productCard":"ProductCard_productCard__FudwS","eventTime":"ProductCard_eventTime__3umhg","wishlistWrapper":"ProductCard_wishlistWrapper__2hQZY"};